let modal = document.getElementById("myModal");
let btnProductForm = document.getElementById("btnProductForm");
let btn = document.getElementById("myBtn");
let span = document.getElementsByClassName("close")[0];
let overlay = document.getElementById("overlayElement");

btn.onclick = function() {
  toggleOverlay();
  setTimeout(function() {
      modal.style.display = "block";
      modal.classList.add('is-active');
  }, 50);
}

btnProductForm.onclick = function() {
  modal.style.display = "block";
  modal.classList.add('is-active');
  toggleOverlay();
}

span.onclick = function() {
  modal.style.display = "none";
  modal.classList.remove('is-active'); 
  removeOverlay();
}

window.onclick = function(event) {
  if (event.target == overlay) {
    modal.style.display = "none";
    modal.classList.remove('is-active'); 
    removeOverlay();
  }
}

document.onkeydown = function(event) {
  if (event.key === "Escape" && event.target === btn) {
    modal.style.display = "none";
    modal.classList.remove('is-active');
    removeOverlay();
  }
}

window.onload = function() {
  if (window.jQuery) {
    let $ = window.jQuery;

    $(function() {
      
      var holiDays = ["01-01-22","01-21-21","05-27-21","07-04-21","09-02-21","11-11-21","11-28-21","12-25-21",""];

        function disableDates(date) {
            var dt = $.datepicker.formatDate('mm-dd-y', date);
            var noWeekend = [date.getDay()==0||date.getDay()==1||date.getDay()==2||date.getDay()==3||date.getDay()==4||date.getDay()==5||date.getDay()==6];

            return noWeekend[0] ? (($.inArray(dt, holiDays) < 0) ? [true] : [false]) : noWeekend;
        }
      
         $("#ContactFormAppointment").datetimepicker({
            showsTime: true,
            hourMin: 9,
            hourMax: 16,
            stepMinute: 30,
            showOn: "focus",

            buttonImage: "https://warwickjewelers.com/static/frontend/sas/theme/en_US/images/calendar.png",
            buttonImageOnly: true,
            buttonText: "Select date",
            minDate: +1,
            maxDate: "+4w",
            beforeShowDay: disableDates
        });
    });
  }
}

function toggleOverlay() {
  let overlay = document.getElementById("overlayElement");
  overlay.classList.toggle("active");
}

function removeOverlay() {
  let overlay = document.getElementById("overlayElement");
  overlay.classList.remove("active");
}